// extracted by mini-css-extract-plugin
export default {"centeredContainer":"styles_centeredContainer__hVSp8","alertText":"styles_alertText__aeUnA"};